import { render, staticRenderFns } from "./ReportHistory.vue?vue&type=template&id=c9f0e36a&scoped=true&"
import script from "./ReportHistory.vue?vue&type=script&lang=js&"
export * from "./ReportHistory.vue?vue&type=script&lang=js&"
import style0 from "./ReportHistory.vue?vue&type=style&index=0&id=c9f0e36a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f0e36a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
